import * as React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { translations } from '../../../../../locales/translations';

export function AcknowledgeDialog(props) {
  const { open, closeDialog, confirmAndCloseDialog, selectedPreviewSection, contractInfoIsPending, selectedSectionIsPending } = props;
  const { t } = useTranslation();

  return (
    <Wrapper>
      {selectedPreviewSection &&
      <Dialog open={open} onClose={closeDialog} className='dialog'>
        <DialogTitle className='dialog-title'>
          {t(translations.contractDetail.acknowledgementHeader) + 
            (contractInfoIsPending ? 'Contract Info' : '') + 
            (contractInfoIsPending && selectedSectionIsPending ? ', ' : '') +
            (selectedSectionIsPending ? `${selectedPreviewSection.charAt(0).toUpperCase()}${selectedPreviewSection.slice(1)}` : '')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className='dialog-desc'>
            {t(translations.contractDetail.acknowledgementDesc)}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Cancel</Button>
          <Button onClick={confirmAndCloseDialog}>Confirm</Button>
        </DialogActions>
      </Dialog>
      }
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .form-group {
    margin: 10px;
  }
`;
